module.exports = __webpack_public_path__ + "img/right-corner.6e82f052.svg";